import { render } from "./ListGroupForm.vue?vue&type=template&id=ba5e5a46"
import script from "./ListGroupForm.vue?vue&type=script&lang=js"
export * from "./ListGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__